/* Reformer Pilates Academy – landing page logic (Webflex)
 * Bron van waarheid: window.RPA (uit sections/rpa-dates.liquid):
 *   { productId, handle, groupSize, vat, taxesIncluded, basePrice (excl. btw, EUR),
 *     tiers:[{min,max,pct,code}], weeks:[{id,title,start,end,left,available}],
 *     checkoutMode:'direct', clearCart:true, lang:'nl', enableEn:true }
 */
(function () {
  'use strict';
  var root = document.querySelector('.rpa');
  if (!root || !window.RPA) return;
  var CFG = window.RPA;

  /* ---------- i18n ---------- */
  var UI = {
    nl: {
      months: ["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],
      monthsLong: ["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],
      to: "tot", course: CFG.courseName || "Reformer Instructeur Level A", loc: CFG.location || "Roosendaal",
      head: ["Week","Opleiding","Locatie","Beschikbaar",""],
      left: function (n) { return n === 1 ? "Nog 1 plek" : "Nog " + n + " plekken"; },
      full: "Volgeboekt", closed: "Gesloten", reserve: "Reserveer", reserveDuo: "Reserveer duo",
      reserveN: function (n) { return "Reserveer " + n + " plekken"; },
      scarcity: function (d, n) { return "Volgende start " + d + ". Nog " + n + " van de " + CFG.groupSize + " plekken vrij."; },
      stickyLeft: function (n) { return "Nog " + n + " plekken vrij"; },
      stickyDate: function (d) { return "Start " + d; },
      noneOpen: "Nieuwe data volgen binnenkort.",
      perPerson: "per persoon, excl. btw",
      inclPP: function (v) { return v + " per persoon incl. btw"; },
      saveDuo: function (v) { return "Samen besparen jullie " + v; },
      perSpot: "per plek", incl: function (v) { return v + " incl. btw"; },
      mTitle: "Wie gaan er mee?", mSub: function (w, n) { return n === 1 ? "Jouw plek voor de week van " + w + "." : n + " plekken voor de week van " + w + "."; },
      mName: function (i) { return "Naam deelnemer " + i; }, mNameSolo: "Je volledige naam",
      mNote: "Opmerking (optioneel)", mBtn: "Door naar afrekenen", mBusy: "Een moment…",
      mErr: "Vul de naam van iedere deelnemer in.", mFail: "Er ging iets mis. Probeer het opnieuw of neem contact op.",
      mTotal: "Totaal", mTotalIncl: "incl. btw", mNotEnough: function (n) { return "Er zijn nog maar " + n + " plekken in deze week."; },
      locale: "nl-NL"
    },
    en: {
      months: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"],
      monthsLong: ["January","February","March","April","May","June","July","August","September","October","November","December"],
      to: "to", course: CFG.courseNameEn || "Reformer Instructor Level A", loc: CFG.location || "Roosendaal",
      head: ["Week","Course","Location","Availability",""],
      left: function (n) { return n === 1 ? "Only 1 spot left" : n + " spots left"; },
      full: "Fully booked", closed: "Closed", reserve: "Reserve", reserveDuo: "Reserve duo",
      reserveN: function (n) { return "Reserve " + n + " spots"; },
      scarcity: function (d, n) { return "Next start " + d + ". Only " + n + " of " + CFG.groupSize + " spots left."; },
      stickyLeft: function (n) { return n + " spots left"; },
      stickyDate: function (d) { return "Starts " + d; },
      noneOpen: "New dates coming soon.",
      perPerson: "per person, excl. VAT",
      inclPP: function (v) { return v + " per person incl. VAT"; },
      saveDuo: function (v) { return "Together you save " + v; },
      perSpot: "per spot", incl: function (v) { return v + " incl. VAT"; },
      mTitle: "Who's coming?", mSub: function (w, n) { return n === 1 ? "Your spot for the week of " + w + "." : n + " spots for the week of " + w + "."; },
      mName: function (i) { return "Name of participant " + i; }, mNameSolo: "Your full name",
      mNote: "Note (optional)", mBtn: "Continue to checkout", mBusy: "One moment…",
      mErr: "Please enter the name of every participant.", mFail: "Something went wrong. Please try again or contact us.",
      mTotal: "Total", mTotalIncl: "incl. VAT", mNotEnough: function (n) { return "Only " + n + " spots left in this week."; },
      locale: "nl-NL"
    }
  };

  var lang = "nl";
  var seats = 1;        // Solo (1) / Duo (2) / team (n) voor de datalijst
  var teamSeats = 3;    // calculator
  var NLDICT = {};
  var nodes = root.querySelectorAll("[data-i18n]");
  nodes.forEach(function (el) { NLDICT[el.dataset.i18n] = el.innerHTML; });
  var altNodes = root.querySelectorAll("[data-i18n-alt]");
  altNodes.forEach(function (el) { NLDICT[el.dataset.i18nAlt] = el.alt; });

  var eur = function (v) { return "€" + v.toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var r2 = function (v) { return Math.round(v * 100) / 100; };
  var tierFor = function (n) {
    var t = null;
    (CFG.tiers || []).forEach(function (x) { if (n >= x.min && n <= x.max) t = x; });
    return t;
  };
  var discount = function (n) { var t = tierFor(n); return t ? t.pct / 100 : 0; };
  var pp = function (n) { return r2(CFG.basePrice * (1 - discount(n))); };
  var vatF = 1 + CFG.vat;

  var parse = function (s) { if (!s) return null; var p = s.split("-").map(Number); return new Date(p[0], p[1] - 1, p[2]); };
  var today = new Date(); today.setHours(0, 0, 0, 0);

  /* Datum uit varianttitel ("12 okt t/m 16 okt", "28 sept. t/m 02 okt", "12 jan t/m 02 feb") als er geen metafield is */
  var MONTHMAP = { jan:0, feb:1, mrt:2, mar:2, apr:3, mei:4, may:4, jun:5, jul:6, aug:7, sep:8, sept:8, okt:9, oct:9, nov:10, dec:11 };
  function parseTitle(t) {
    var m = String(t).toLowerCase().replace(/\./g, "").match(/(\d{1,2})\s*([a-z]+)?\s*(?:t\/m|tot|-|–)\s*(\d{1,2})\s*([a-z]+)/);
    if (!m) return null;
    var em = MONTHMAP[m[4]]; if (em === undefined) return null;
    var sm = m[2] ? MONTHMAP[m[2]] : em; if (sm === undefined) sm = em;
    var y = today.getFullYear();
    var start = new Date(y, sm, +m[1]), end = new Date(y, em, +m[3]);
    if (end < start) end = new Date(y + 1, em, +m[3]);
    // nearest-year: als de week > 60 dagen geleden eindigde, hoort hij bij volgend jaar
    if (end.getTime() < today.getTime() - 60 * 864e5) { start.setFullYear(start.getFullYear() + 1); end.setFullYear(end.getFullYear() + 1); }
    return { start: start, end: end };
  }
  var weeks = (CFG.weeks || []).filter(function (w) { return !w.hidden; }).map(function (w) {
    var s = parse(w.start), e = parse(w.end);
    if (!s || !e) { var p = parseTitle(w.title); if (p) { s = p.start; e = p.end; } }
    return { id: w.id, title: w.title, start: s, end: e, left: Math.max(0, +w.left || 0), available: !!w.available };
  }).filter(function (w) { return w.start; }).sort(function (a, b) { return a.start - b.start; });

  function range(w) {
    var u = UI[lang], a = w.start, b = w.end;
    if (/,/.test(w.title || "")) { var nn = String(w.title).match(/\d{1,2}(?!\d)/g) || []; if (nn.length > 2) { var last = nn.pop(); return nn.join(", ") + " " + (lang === "en" ? "and" : "en") + " " + last + " " + u.months[b.getMonth()]; } }
    return a.getMonth() === b.getMonth()
      ? a.getDate() + " " + u.to + " " + b.getDate() + " " + u.months[b.getMonth()]
      : a.getDate() + " " + u.months[a.getMonth()] + " " + u.to + " " + b.getDate() + " " + u.months[b.getMonth()];
  }
  function longDate(d) { var u = UI[lang]; return d.getDate() + " " + u.monthsLong[d.getMonth()]; }
  function isOpen(w) { return w.available && w.left > 0 && w.start > today; }
  function isVisible(w) { // afgelopen weken verbergen, behalve de laatste volgeboekte (14 dagen) zodat je ziet hoe snel ze gaan
    if (w.end >= today) return true;
    return (today - w.end) < 14 * 864e5;
  }
  function nextWeek() { for (var i = 0; i < weeks.length; i++) if (isOpen(weeks[i])) return weeks[i]; return null; }

  /* ---------- Rendering ---------- */
  function renderWeeks() {
    var u = UI[lang], host = root.querySelector(".js-weeks");
    if (!host) return;
    var html = '<div class="wk head">' + u.head.map(function (h) { return "<span>" + h + "</span>"; }).join("") + "</div>";
    var any = false;
    weeks.forEach(function (w) {
      if (!isVisible(w)) return;
      any = true;
      var open = isOpen(w);
      var enough = w.left >= seats;
      var pct = Math.round((CFG.groupSize - w.left) / CFG.groupSize * 100);
      var cls = ["wk", open ? "" : "closed", open && w.left <= 5 ? "low" : "", open && !enough ? "notenough" : ""].join(" ");
      var label = seats === 2 ? u.reserveDuo : seats > 2 ? u.reserveN(seats) : u.reserve;
      html += '<div class="' + cls + '" data-week="' + w.id + '">' +
        '<span class="date">' + range(w) + "</span>" +
        '<span class="course">' + u.course + "</span>" +
        '<span class="loc">' + u.loc + "</span>" +
        '<span class="avail">' + (open ? '<span class="bar"><i style="width:' + pct + '%"></i></span>' + u.left(w.left) : u.full) + "</span>" +
        '<span class="act">' + (open ? '<button type="button" class="btn btn-primary js-reserve" data-week="' + w.id + '">' + label + "</button>" : '<span class="closed-lbl">' + u.closed + "</span>") + "</span>" +
        "</div>";
    });
    if (!any) html += '<p class="lead">' + u.noneOpen + "</p>";
    host.innerHTML = html;
  }

  function renderScarcity() {
    var u = UI[lang], w = nextWeek();
    root.querySelectorAll(".js-scarcity").forEach(function (el) { el.textContent = w ? u.scarcity(longDate(w.start), w.left) : u.noneOpen; });
    var d = root.querySelector(".js-sticky-date"), l = root.querySelector(".js-sticky-left");
    if (d) d.textContent = w ? u.stickyDate(longDate(w.start)) : "";
    if (l) l.textContent = w ? u.stickyLeft(w.left) : u.noneOpen;
  }

  function setText(sel, txt, html) { var el = root.querySelector(sel); if (el) { if (html) el.innerHTML = txt; else el.textContent = txt; } }
  function renderPrices() {
    var u = UI[lang], solo = pp(1), duo = pp(2);
    setText(".js-solo-pp", eur(solo));
    setText(".js-solo-incl", u.perPerson + " · " + u.incl(eur(r2(solo * vatF))));
    setText(".js-duo-pp", eur(duo));
    setText(".js-duo-old", eur(solo));
    setText(".js-duo-incl", u.perPerson + " · " + u.inclPP(eur(r2(duo * vatF))));
    setText(".js-duo-save", u.saveDuo(eur(r2((solo - duo) * 2))));
    root.querySelectorAll(".tier").forEach(function (t) {
      var el = t.querySelector(".pp"); if (el) el.innerHTML = eur(pp(+t.dataset.min)) + "<small> " + u.perSpot + "</small>";
    });
    renderCalc();
  }

  function renderCalc() {
    var u = UI[lang], n = teamSeats, per = pp(n), total = r2(per * n);
    setText(".js-seats", n);
    setText(".js-c-per", eur(per));
    setText(".js-c-save", eur(r2((CFG.basePrice - per) * n)));
    setText(".js-c-total", eur(total));
    setText(".js-c-incl", u.incl(eur(r2(total * vatF))));
    root.querySelectorAll(".tier").forEach(function (t) { t.classList.toggle("on", n >= +t.dataset.min && n <= +t.dataset.max); });
  }

  function setSeats(n, scroll) {
    seats = n;
    root.querySelectorAll(".seg button").forEach(function (b) { b.setAttribute("aria-pressed", String(+b.dataset.seats === n)); });
    renderWeeks();
    if (scroll) { var d = root.querySelector("#data"); if (d) d.scrollIntoView({ behavior: "smooth", block: "start" }); }
  }

  function setLang(l) {
    lang = (l === "en" && (CFG.enableEn || CFG.nativeLocale)) ? "en" : "nl";
    // Bij echte Shopify-talen komt de vertaalde tekst al uit Liquid; dan niets in de DOM vervangen
    var dict = CFG.nativeLocale ? {} : (lang === "en" ? (window.RPA_EN || {}) : NLDICT);
    nodes.forEach(function (el) { var v = dict[el.dataset.i18n]; if (v !== undefined) el.innerHTML = v; });
    altNodes.forEach(function (el) { var v = dict[el.dataset.i18nAlt]; if (v !== undefined) el.alt = v; });
    document.documentElement.lang = lang;
    root.querySelectorAll(".lang button").forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.lang === lang)); });
    try { localStorage.setItem("rpa-lang", lang); } catch (e) {}
    renderWeeks(); renderScarcity(); renderPrices();
    try { document.dispatchEvent(new CustomEvent("rpa:lang", { detail: lang })); } catch (e) {}
  }

  /* ---------- Events ---------- */
  root.querySelectorAll(".lang button").forEach(function (b) { b.addEventListener("click", function () { setLang(b.dataset.lang); }); });
  root.querySelectorAll(".lang a").forEach(function (a) { a.addEventListener("click", function () { try { localStorage.setItem("rpa-lang", a.dataset.lang); } catch (e) {} }); });
  root.querySelectorAll(".seg button").forEach(function (b) { b.addEventListener("click", function () { setSeats(+b.dataset.seats, false); }); });
  root.querySelectorAll("[data-pick]").forEach(function (a) { a.addEventListener("click", function () { setSeats(+a.dataset.pick, false); }); });
  var minus = root.querySelector(".js-minus"), plus = root.querySelector(".js-plus");
  if (minus) minus.addEventListener("click", function () { teamSeats = Math.max(1, teamSeats - 1); renderCalc(); });
  if (plus) plus.addEventListener("click", function () { teamSeats = Math.min(CFG.groupSize, teamSeats + 1); renderCalc(); });
  var teamCta = root.querySelector(".js-team-cta");
  if (teamCta) teamCta.addEventListener("click", function (e) { e.preventDefault(); setSeats(teamSeats, true); });

  var video = root.querySelector(".js-video");
  if (video) {
    var vidWrap = video.parentElement, playBtn = root.querySelector(".js-play");
    if (playBtn) playBtn.addEventListener("click", function () { video.play().catch(function () {}); });
    video.addEventListener("play", function () { vidWrap.classList.add("playing"); });
    video.addEventListener("ended", function () { vidWrap.classList.remove("playing"); });
  }

  var sticky = root.querySelector(".js-sticky"), heroEl = root.querySelector(".hero"), finalEl = root.querySelector(".final");
  if (sticky && heroEl && finalEl) {
    // Horizon scrolt binnen .page-wrapper, dus luisteren op capture-niveau (vangt elke scroller)
    var onScroll = function () {
      var r1 = heroEl.getBoundingClientRect(), r2b = finalEl.getBoundingClientRect();
      sticky.classList.toggle("show", r1.bottom < 0 && r2b.top > window.innerHeight);
    };
    document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    onScroll();
  }

  /* ---------- Reserveren: namen → cart → checkout ---------- */
  var modal = root.querySelector(".js-book");
  function openModal(w) {
    if (!modal) return;
    var u = UI[lang], n = seats;
    if (w.left < n) { alert(u.mNotEnough(w.left)); return; }
    modal.dataset.week = w.id;
    modal.querySelector(".js-b-title").textContent = u.mTitle;
    modal.querySelector(".js-b-sub").textContent = u.mSub(range(w), n);
    var fields = modal.querySelector(".js-b-fields"), html = "";
    for (var i = 1; i <= n; i++) {
      html += '<label class="b-field"><span>' + (n === 1 ? u.mNameSolo : u.mName(i)) + '</span><input type="text" name="deelnemer_' + i + '" autocomplete="' + (i === 1 ? "name" : "off") + '" required></label>';
    }
    html += '<label class="b-field"><span>' + u.mNote + '</span><input type="text" name="opmerking" maxlength="200"></label>';
    fields.innerHTML = html;
    var per = pp(n), total = r2(per * n);
    modal.querySelector(".js-b-total").innerHTML = '<span>' + u.mTotal + '</span><b>' + eur(total) + '</b><small>' + eur(r2(total * vatF)) + ' ' + u.mTotalIncl + '</small>';
    modal.querySelector(".js-b-submit").textContent = u.mBtn;
    modal.querySelector(".js-b-err").textContent = "";
    modal.classList.add("open"); document.body.classList.add("rpa-lock");
    var first = fields.querySelector("input"); if (first) setTimeout(function () { first.focus(); }, 50);
  }
  function closeModal() { if (!modal) return; modal.classList.remove("open"); document.body.classList.remove("rpa-lock"); }
  root.addEventListener("click", function (e) {
    var b = e.target.closest(".js-reserve");
    if (b) { var w = weeks.filter(function (x) { return String(x.id) === String(b.dataset.week); })[0]; if (w) openModal(w); }
    if (e.target.closest(".js-b-close") || e.target.classList.contains("b-backdrop")) closeModal();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeModal(); });

  function post(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  if (modal) modal.querySelector("form").addEventListener("submit", function (e) {
    e.preventDefault();
    var u = UI[lang], form = e.target, btn = modal.querySelector(".js-b-submit"), err = modal.querySelector(".js-b-err");
    var n = seats, names = [], props = {};
    for (var i = 1; i <= n; i++) {
      var v = (form.elements["deelnemer_" + i].value || "").trim();
      if (!v) { err.textContent = u.mErr; form.elements["deelnemer_" + i].focus(); return; }
      names.push(v); props[(lang === "en" ? "Participant " : "Deelnemer ") + i] = v;
    }
    var note = (form.elements["opmerking"].value || "").trim();
    if (note) props[lang === "en" ? "Note" : "Opmerking"] = note;
    props["_Week"] = modal.dataset.week;
    var variantId = +modal.dataset.week;
    btn.disabled = true; btn.textContent = u.mBusy; err.textContent = "";
    var chain = CFG.clearCart ? post("/cart/clear.js", {}) : Promise.resolve();
    chain.then(function () {
      return post("/cart/add.js", { items: [{ id: variantId, quantity: n, properties: props }] });
    }).then(function () {
      var noteTxt = (lang === "en" ? "Participants (" : "Deelnemers (") + n + "): " + names.join(", ") + (note ? (lang === "en" ? " | Note: " : " | Opmerking: ") + note : "");
      return post("/cart/update.js", { note: noteTxt, attributes: { "Aantal plekken": String(n), "Taal": lang } });
    }).then(function () {
      var t = tierFor(n), code = t && t.code ? t.code : "";
      if (code) {
        return fetch("/discount/" + encodeURIComponent(code), { headers: { accept: "text/html" } }).catch(function () {}).then(function () {
          window.location.href = "/checkout?discount=" + encodeURIComponent(code);
        });
      }
      window.location.href = "/checkout";
    }).catch(function (x) {
      btn.disabled = false; btn.textContent = u.mBtn;
      err.textContent = (x && (x.description || x.message)) ? (x.description || x.message) : u.mFail;
    });
  });

  /* ---------- Start ---------- */
  var q = new URLSearchParams(location.search);
  var start = CFG.nativeLocale ? (CFG.lang || "nl") : q.get("lang");
  if (!start) { try { start = localStorage.getItem("rpa-lang") || "nl"; } catch (e) { start = "nl"; } }
  var qs = parseInt(q.get("seats"), 10); if (qs > 0 && qs <= CFG.groupSize) { seats = qs; if (qs > 2) teamSeats = qs; }
  setLang(start);
  if (q.get("week")) { var tgt = root.querySelector("#data"); if (tgt) tgt.scrollIntoView(); }
})();
